import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";
import { militaryContactEdit_template } from "../components/templates/militaryContactEdit_template";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = "1.2.0";

let militaryContactBodyEditor;
let militaryContactHoursEditor;

export class military_contact_edit extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: militaryContactEdit_template;
    protected XHRHdlCaller: string;
    protected pendingReferenceViewUrl: string = "";

    protected getModuleName() {
        return "military_contact_edit";
    }

    buildContent(): Array<Element> {
        this.editForm = new militaryContactEdit_template("editForm", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Military Contact Edit");

        return [this.editForm.build()];
    }

    public fillPage(): void {
        this.initializeRichTextEditors();
        if (this.getContactId()) {
            this.getContact();
        } else {
            this.getLookups();
        }
    }

    protected getContact(): void {
        this.loadingIn(this.editForm.builtTemplate);
        let url = "/api/brand/" + this.getBrandId() + "/military-base-guides/contacts/get/" + this.getContactId() + "/";
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON({ lockItem: true })]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetContactReturn;
        this.XHRHdl.execute();
    }

    protected onGetContactReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.editForm.setBases(responseParsed.bases || []);
                obj.editForm.setAddressLookups(responseParsed.countries || [], responseParsed.usStates || []);
                obj.editForm.setContact(responseParsed.contact);
                obj.editForm.setReferencedHelpServices(responseParsed.referencedHelpServices || []);
                obj.editForm.setReferencedBases(responseParsed.referencedBases || []);
                obj.setBodyEditorData(obj.editForm.getTemplateViewModel().body());
                obj.setHoursEditorData(obj.editForm.getTemplateViewModel().hours());
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    protected getLookups(): void {
        this.loadingIn(this.editForm.builtTemplate);
        let url = "/api/brand/" + this.getBrandId() + "/military-base-guides/lookups/";
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON({})]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetLookupsReturn;
        this.XHRHdl.execute();
    }

    protected onGetLookupsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.editForm.setBases(responseParsed.bases || []);
                obj.editForm.setAddressLookups(responseParsed.countries || [], responseParsed.usStates || []);
                obj.editForm.setDefaultBase(obj.getDefaultBaseId());
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    protected saveContact(): void {
        this.validationTemplate.clearMessages();
        this.loadingIn(this.editForm.builtTemplate);
        this.XHRHdlCaller = "save";
        this.syncRichTextEditorsToViewModel();

        let url = "/api/brand/" + this.getBrandId() + "/military-base-guides/contacts/save/";
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.editForm.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveContactReturn;
        this.XHRHdl.execute();
    }

    protected onSaveContactReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Military contact saved successfully.");
                if (obj.getContactId()) {
                    obj.releaseLock("save");
                } else {
                    let contact = JSON.parse(req.request.response).data.contact;
                    page.redirect("/brand/" + obj.getBrandId() + "/military-base-guides/contacts/view/" + contact.id);
                }
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        };
    }

    protected releaseLock(actionSource: string): void {
        let url = "/api/brand/" + this.getBrandId() + "/military-base-guides/contacts/release/" + this.getContactId() + "/";
        this.XHRHdlCaller = actionSource;
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onReleaseLockReturn;
        this.XHRHdl.execute();
    }

    protected onReleaseLockReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                if (obj.XHRHdlCaller == "save") {
                    page.redirect("/brand/" + obj.getBrandId() + "/military-base-guides/contacts/view/" + obj.getContactId());
                } else if (obj.XHRHdlCaller == "viewReference") {
                    page.redirect(obj.pendingReferenceViewUrl);
                } else {
                    page.redirect(obj.getVnAppZone().app.getLastRoute());
                }
            });
        };
    }

    protected cancel(): void {
        if (this.getContactId()) {
            this.releaseLock("cancel");
            return;
        }
        page("/brand/" + this.getBrandId() + "/military-base-guides/contacts");
    }

    protected viewReferencedHelpService(helpService): void {
        if (helpService && helpService.idBase) {
            this.viewReference("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + helpService.idBase);
        }
    }

    protected viewReferencedBase(base): void {
        if (base && base.id) {
            this.viewReference("/brand/" + this.getBrandId() + "/military-base-guides/bases/view/" + base.id);
        }
    }

    protected viewReference(url: string): void {
        if (!url) {
            return;
        }

        this.pendingReferenceViewUrl = url;
        if (this.getContactId()) {
            this.releaseLock("viewReference");
            return;
        }

        page(url);
    }

    protected initializeRichTextEditors(): void {
        if (typeof CKEDITOR == "undefined") {
            return;
        }
        if (CKEDITOR.instances.military_contact_hours) {
            CKEDITOR.instances.military_contact_hours.destroy(true);
        }
        if (CKEDITOR.instances.military_contact_body) {
            CKEDITOR.instances.military_contact_body.destroy(true);
        }

        if (!CKEDITOR.stylesSet.registered.my_styles) {
             CKEDITOR.stylesSet.add("my_styles", [
               // Block-level styles.
               // { name: "Heading 1", element: "h1" },
               { name: "Heading 2", element: "h2" },
               { name: "Heading 3", element: "h3" },
               { name: "Preformatted", element: "pre" },
               { name: "Quote", element: "blockquote" },
               { name: "Code", element: "code" },
               // Inline styles.
               {
                 name: "Related: One link",
                 element: "span",
                 attributes: { class: "related-single" },
               },
               {
                 name: "Next - One link",
                 element: "span",
                 attributes: { class: "next-single" },
               },
               {
                 name: "Affiliate - One link",
                 element: "span",
                 attributes: { class: "affiliate-single" },
               },
               {
                 name: "Spoiler Alert",
                 element: "span",
                 attributes: { class: "article-alert" },
               },
               {
                 name: "Tip",
                 element: "div",
                 attributes: { class: "emaki-custom tip" },
               },
               {
                 name: "Warning",
                 element: "div",
                 attributes: { class: "emaki-custom warning" },
               },
               {
                 name: "Note",
                 element: "div",
                 attributes: { class: "emaki-custom note" },
               },
               {
                 name: "Expandable",
                 element: "div",
                 attributes: { class: "emaki-custom expandable" },
               },
               {
                 name: "Pullquote",
                 element: "div",
                 attributes: { class: "emaki-custom pullquote" },
               },
               {
                 name: "Promoted",
                 element: "div",
                 attributes: { class: "emaki-custom promoted" },
               },
               {
                 name: "Drop Cap",
                 element: "div",
                 attributes: { class: "emaki-custom paragraph-dropcap" },
               },
               {
                 name: "Float Image Left",
                 element: "div",
                 attributes: { class: "emaki-custom wrap-image" },
               },
               {
                 name: "Float Image Right",
                 element: "div",
                 attributes: { class: "emaki-custom wrap-image-right" },
               },
               {
                 name: "Float Badge Left",
                 element: "div",
                 attributes: { class: "emaki-custom wrap-badge-left" },
               }
             ]);
           }

        const basicConfig = {
            toolbar: [
                {
                    name: "basicstyles",
                    items: ["Bold", "Italic", "Strike", "Link", "EmojiPanel"],
                },
            ],
            extraPlugins: "emoji",
            removeButtons: "",
            disallowedContent: "p",
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: "p",
            },
            enterMode: CKEDITOR.ENTER_BR
        };

        // CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;
        CKEDITOR.replace("military_contact_hours", basicConfig);
        militaryContactHoursEditor = CKEDITOR.instances.military_contact_hours;
        militaryContactHoursEditor.on("change", () => {
            this.editForm.getTemplateViewModel().hours(militaryContactHoursEditor.getData());
        });

        CKEDITOR.replace("military_contact_body", basicConfig);
        militaryContactBodyEditor = CKEDITOR.instances.military_contact_body;
        militaryContactBodyEditor.on("change", () => {
            this.editForm.getTemplateViewModel().body(militaryContactBodyEditor.getData());
        });
    }

    protected setBodyEditorData(value): void {
        if (militaryContactBodyEditor) {
            militaryContactBodyEditor.setData(value || "");
        }
    }

    protected setHoursEditorData(value): void {
        if (militaryContactHoursEditor) {
            militaryContactHoursEditor.setData(value || "");
        }
    }

    protected syncRichTextEditorsToViewModel(): void {
        if (militaryContactHoursEditor) {
            this.editForm.getTemplateViewModel().hours(militaryContactHoursEditor.getData());
        }
        if (militaryContactBodyEditor) {
            this.editForm.getTemplateViewModel().body(militaryContactBodyEditor.getData());
        }
    }

    public cleanup(): void {
        if (typeof CKEDITOR === "undefined") {
            return;
        }

        const editorNames = ["military_contact_body", "military_contact_hours"];
        editorNames.forEach((name) => {
            if (CKEDITOR.instances && CKEDITOR.instances[name]) {
                CKEDITOR.instances[name].destroy(true);
            }
        });
        militaryContactBodyEditor = undefined;
        militaryContactHoursEditor = undefined;

        if (CKEDITOR.stylesSet && CKEDITOR.stylesSet.registered && CKEDITOR.stylesSet.registered.my_styles) {
            delete CKEDITOR.stylesSet.registered.my_styles;
        }
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    protected getContactId(): number {
        return Number(this.getVnAppZone().app.params.id || 0);
    }

    protected getDefaultBaseId(): number {
        return Number(this.getVnAppZone().app.params.idBase || 0);
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_contact_edit.ts